module.exports = "/_next/static/images/fastcentrik-1a9538eca2736be11ecf0cde22060201.png";